import { useLocation, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { UseContextApp } from "../../../Global/Context/appContext";
import ConsumoController from "../../../controllers/ConsumoController";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import banner from "../../../assets/banner_marca.png";
import { SortDescendingIcon, SortAscendingIcon } from "@heroicons/react/solid";
import { ArrowSmUpIcon } from "@heroicons/react/solid";
import Chart from "react-apexcharts";
import { colors } from "../../../propsType/Colors";
import { TabNavegation } from "../../../propsType/TabNavegation";
import medios from "../../../assets/Banners/NetUnoInternetDetalles2.jpg";
import descargaContrato from "../../../assets/svg/descargar_contrato.svg";



const DetailsInternet = () => {
  const navigate = useNavigate();
  const [deatils, setDeatils] = useState(null);
  const [dataDetalle, setDataDetalle] = useState("");
  const { consumoDetalles } = ConsumoController();
  const [{ user }] = UseContextApp();
  const [gradif, setGradif] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;
  const [listaActual, setDataActual] = useState([]);
  const [listaAnterior, setDataAnterior] = useState([]);
  const { tabsHogarDetails, tabsEmpresaDetails } = TabNavegation(pathName)
  const [tabs, setTabs] = useState(user?.datos?.tipoCliente === 'Hogar' ? tabsHogarDetails : tabsEmpresaDetails || [''])
  const getConsumo = async (item) => {
  
    setLoading(true);
    let dataAnterior = {
      id: user.id,
      status: true,
    };
    let dataActual = {
      id: user.id,
      status: false,
    };
    const res = await consumoDetalles(dataAnterior);
    const res2 = await consumoDetalles(dataActual);

    if (res && res2) {

      const resFilter = res.dtConsumo.filter((res) => res.MAC === deatils?.serial);
      const res2Filter = res2.dtConsumo.filter((res) => res.MAC === deatils?.serial);
      resFilter.map((fill) => {
        var hey = Object.keys(fill).forEach((key) => {
          listaAnterior.push(fill[key]);
        });
        return hey;
      });
      res2Filter.map((fill) => {
        var hey = Object.keys(fill).forEach((key) => {
          listaActual.push(fill[key]);
        });
        return hey;
      });

      setLoading(false);
      setDataDetalle(res);
      setGradif(true);
    } else {
      setLoading(false);
    }
  };
  const stats = [
    {
      name: "Número de Cuenta",
      stat: deatils?.cuenta,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Número de Contrato",
      stat: deatils?.contrato,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Serial del Equipo",
      stat: deatils?.serial,
      previousStat: "",
      change: deatils?.status,
      changeType: "increase",
    },
  ];

  const statsCard = [
    {
      id: 1,
      name: "Consumo Mes Actual",
      status: false,
      stat: deatils?.consumo + " " + "GB",
      icon: SortAscendingIcon,
      change: "",
      changeType: "increase",
    },
    {
      id: 2,
      name: "Consumo Mes Anterior",
      status: true,
      stat: deatils?.consumo_old + " " + "GB",
      icon: SortDescendingIcon,
      change: "",
      changeType: "increase",
    },
  ];

  //Data para la informacion de la grafica
  const op = {

    series: [
      {
        name: "Actual",

        data: listaActual.slice(6, 37),
      },
      {
        name: "Anterior",
        data: listaAnterior.slice(6, 37),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: false,
            selection: true,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      stroke: {
        curve: "smooth",
        width: [1, 1, 2, 2],
      },

      colors: ["#09101F", "#5AB9E5"],
      xaxis: {
        type: "day",
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
        ],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            return val + "GB";
          },
        },
      },
    },
  };

  op.series[0].data = listaActual.slice(6, 37);
  op.series[1].data = listaAnterior.slice(6, 37);
  const handleDescargarContrato = (e) => {
    e.preventDefault();
  
    // Obtener la URL actual y agregar el parámetro `send_message`
    const currentPath = location.pathname;
    const newUrl = `${currentPath}?send_message=Copia%20de%20contrato`;
  
    // Navegar a la misma página con el parámetro añadido en la URL
    navigate(newUrl, { state: { ...location.state }, replace: true });
  
    // Recargar el componente sin perder `location.state`
    setTimeout(() => {
      navigate(0);
    }, 100);
  };
   
  //Funcion para el selector de la navegacion (SOLO RESPONSIVE)
  function handleChangeRoute(e) {
  
    let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
           navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Televisión":
        navigate("/cuenta/servicio-de-television");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      default:
        break;
    }
  }
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  useEffect(() => {    
    setDeatils(location?.state?.data);
  }, [location.state]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  
  return (
    <>
      {loading ? (
        <>
          <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
            <Spinner title={"Espere..."} />
          </div>
        </>
      ) : (
        <>
        
          <div className=" relative bg-[#f3f4f6]">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
              <div className="flex lg:w-full gap-5 p-[20px] lg:p-2 overflow-auto flex-col">
                <BreadCrumbsGeneric locations={pathName} />
                <div>
                  <div>
                    <div className="sm:hidden">
                      <label htmlFor="tabs" className="sr-only">
                        Select a tab
                      </label>
                      <select
                        id="tabs"
                        name="tabs"
                        onChange={handleChangeRoute}
                        className="block w-full h-11 p-[10px] shadow focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                        defaultValue={tabs?.find((tab) => tab?.current)?.name}
                      >
                        {tabs?.map((tab) => (
                          <option key={tab.name}>{tab.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="hidden sm:block">
                      <nav
                        className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                        aria-label="Tabs"
                      >
                        {tabs?.map((tab, tabIdx) => (
                          <Link
                            key={tab.name}
                            to={tab.href}
                            className={classNames(
                              tab.current
                                ? "text-gray-900"
                                : "text-gray-500 hover:text-gray-700",
                              tabIdx === 0 ? "rounded-l-lg" : "",
                              tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                              "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                            )}
                            aria-current={tab.current ? "page" : undefined}
                          >
                            <span>{tab.name}</span>
                            <span
                              aria-hidden="true"
                              className={classNames(
                                tab.current
                                  ? `bg-[${colors.lightBlue}]`
                                  : "bg-transparent",
                                "absolute inset-x-0 bottom-0 h-0.5"
                              )}
                            />
                          </Link>
                        ))}
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="">
                  <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                    {stats.map((item, index) => (
                      <div key={item.name} className="px-4 py-5 flex justify-between items-center sm:p-6">
                        <div>
                          <dt className="text-base flex justify-between items-center font-normal text-gray-900 ">
                            {
                              item.name === 'Serial del Equipo' ? (<>
                                <div>  {item.name}</div>

                              </>)
                                :
                                (<>
                                  {item.name}
                                </>)
                            }
                          </dt>
                          <dd className="mt-1 flex justify-between items-center md:block lg:flex">
                            <div
                              className={`flex items-baseline text-2xl font-semibold text-[${colors.lightBlue}] `}
                            >
                              {item.stat ? <> {item.stat}</> : <>No Disponible</>}
                              <span className="ml-2 text-sm font-medium text-gray-500">
                                {item.previousStat}
                              </span>
                            </div>

                          </dd>
                        </div>
                        {
                          index === 2 && (
                            <div className="flex flex-col h-full justify-between">
                              <dt className="text-base flex justify-between items-center font-normal text-gray-900 ">
                                {
                                  item.name === 'Serial del Equipo' ? (<> <div className="mr-[25px] ">Estatus</div> </>)
                                    :
                                    (<>
                                      {item.name}
                                    </>)
                                }
                              </dt>
                              <dd className="mt-1 flex justify-between items-center md:block lg:flex">
                                <div
                                  className={classNames(
                                    item.changeType === "increase" &&
                                    "bg-green-100 text-green-800",
                                    "inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0"
                                  )}
                                >
                                  {item.changeType === "increase" && (
                                    <ArrowSmUpIcon
                                      className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                                      aria-hidden="true"
                                    />
                                  )}
                                  <span className="sr-only">
                                    {item.changeType === "increase"
                                      ? "Increased"
                                      : "Decreased"}
                                    by
                                  </span>
                                  {item.change}
                                </div>
                              </dd>
                            </div>
                          )
                        }


                      </div>
                    ))}
                  </dl>
                </div>
                <div>
                  <main>
                    <div className=" max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-5">
                      <div className="space-y-6 lg:col-start-1 lg:col-span-3">
                        <section aria-labelledby="applicant-information-title">
                          <div className="bg-white shadow h-full sm:rounded-lg">
                            <div className="px-4 py-5 sm:px-6">
                              <h2
                                id="applicant-information-title"
                                className="text-lg leading-6 font-medium text-gray-900"
                              >
                                Detalles de Servicio
                              </h2>
                              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                                Servicios Internet
                              </p>
                            </div>
                            <div className="border-t border-gray-200 px-4 h-full py-5 sm:px-6 ">
                              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Paquete
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.paquete}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Tecnología
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.tecnologia}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Titular
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {user?.datos?.nombreApellido}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Ciudad
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.ciudad}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Fibra
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.isFTTX === "true"
                                      ? "Si"
                                      : "No"}
                                  </dd>
                                </div>
                              </dl>
                            </div>
                        <div className="container-button-internet flex   sm:rounded-b-lg flex-wrap justify-around items-center" style={{ backgroundColor: colors.lightBlue, padding: '8px', }}>
                          <div>
                          <Link
                            state={{ data: { nroCuenta: deatils?.cuenta } }}
                            to={"/cuenta/pagos/estado-de-cuenta"}
                            className={`flex justify-center items-center block bg-[${colors.lightBlue}] text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center px-2 py-2  sm:rounded-lg shadow-lg  border-2 border-[${colors.darkBlue}]`} style={{
                              height: '35px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >                         
                            Ver estado de cuenta
                          </Link>
                          </div>
                          <div>
                          <Link
                            // state={{ data: { nroCuenta: deatils?.cuenta } }}
                            // to={"/cuenta/pagos/estado-de-cuenta"}
                            onClick={(e) => handleDescargarContrato(e)}
                            className={`flex justify-center items-center block bg-[${colors.lightBlue}] text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center px-2 py-2  sm:rounded-lg shadow-lg  border-2 border-[${colors.darkBlue}]`} style={{
                              height: '35px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            <img className="w-[20px] mr-[4px]" src={descargaContrato} alt="" />                                
                            Descargar contrato
                          </Link>
                          </div>
                        </div>                            
                          </div>
                        </section>
                      </div>
                      {deatils?.isFTTX === "true" ? (
                        <>
                          <section
                            aria-labelledby="timeline-title"
                            className="lg:col-span-2 relative"
                          >
                            <div className="bg-white  shadow sm:rounded-lg h-full ">
                              <div className="px-4 py-5 sm:px-6">
                                <h2
                                  id="applicant-information-title"
                                  className="text-lg leading-6 font-medium text-gray-900"
                                >
                                  Consumo de la Cuenta
                                </h2>
                                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                                  Servicios Internet
                                </p>
                              </div>
                              <dl className=" flex flex-col border-t pb-[70px] lg:pb-0 p-5 gap-4 border-gray-200 ">
                                {statsCard.map((item) => (
                                  <div
                                    key={item.id}
                                    className="relative bg-white pl-[20px] pt-5 shadow rounded-lg overflow-hidden"
                                  >
                                    <dt>
                                      <div
                                        className={`absolute bg-[${colors.lightBlue}] rounded-md p-3`}
                                      >
                                        <item.icon
                                          className="h-6 w-6 text-white"
                                          aria-hidden="true"
                                        />
                                      </div>
                                      <p className="ml-16 text-sm font-medium text-gray-500 truncate">
                                        {item.name}
                                      </p>
                                    </dt>
                                    <dd className="ml-16 pb-6 flex items-baseline ">
                                      <p className="text-2xl font-semibold text-gray-900">
                                        {item.stat}
                                      </p>
                                    </dd>
                                  </div>
                                ))}
                              </dl>
                              <div className="absolute bottom-0 w-full">
                                {gradif ? (
                                  <>
                                    <div
                                      className={`block  bg-[${colors.lightBlue}] text-md  hover:bg-[${colors.darkBlue}] text-sm font-medium text-white text-center px-4 py-4  sm:rounded-b-lg`} style={{
                                        height: '51px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}
                                    >
                                      Ver Detalle del Consumox
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      onClick={() => getConsumo()}
                                      className={`block bg-[${colors.lightBlue}] text-md text-white hover:bg-[${colors.darkBlue}] cursor-pointer  duration-300 easy hover:text-white text-sm font-medium  text-center px-4 py-4  sm:rounded-b-lg`} style={{
                                        height: '51px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}
                                    >
                                      Ver Detalle del Consumo
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </section>
                        </>
                      ) : (
                        <>
                          <div className="lg:col-span-2">
                            <img
                              className="w-full  cover rounded-[10px] h-[381px] shadow-lg"
                              src={banner}
                              alt=""
                            />
                          </div>
                        </>
                      )}                  
                    </div>
                  </main>
                </div>
                {gradif && (
                  <>
                    <div className="bg-white shadow  sm:rounded-lg">
                      <div className="flex flex-col gap-4">
                        <div className=" py-5 sm:px-6 border-b  border-gray-200 ">
                          <h2
                            id="applicant-information-title"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Consumo del mes
                          </h2>
                          <p className="mt-1 max-w-2xl text-sm text-gray-500">
                            El consumo del mes actual sólo contiene información
                            hasta el día anterior
                          </p>
                        </div>
                        <div className="  px-5 py-5">
                          <Chart
                            subtitle={op.subtitle}
                            options={op.options}
                            series={op.series}
                            type="area"
                            width="100%"
                            height="400"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <img className="w-full h-full rounded-t-lg" src={medios} alt="" /> 
              </div>                  
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DetailsInternet;
